// ─────────────────────────────────────────────────────────────────────────────
// icons.js — the two zoom glyphs in the map toolbar. Dashed strokes that inherit
// `currentColor`, so the button's CSS controls colour and hover state.
// ─────────────────────────────────────────────────────────────────────────────
const line = {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeDasharray: "1.5 2",
};

export const ZoomOutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <line x1="4" y1="9" x2="14" y2="9" {...line} />
  </svg>
);

export const ZoomInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <line x1="9" y1="3" x2="9" y2="15" {...line} />
    <line x1="3" y1="9" x2="15" y2="9" {...line} />
  </svg>
);
